import * as React from 'react';
import { useState, useEffect } from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { RangeSlider } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const FacetInputPriceRange = ({ min: min1 , max: max1 , value , facetLabel , onChange , renderNumber =(v)=>v
  })=>{
    const { currency , getLabel  } = useIntl();
    const [range, setRange] = useState(value);
    useEffect(()=>setRange(value)
    , [
        value.min,
        value.max
    ]);
    const handleAfterChange = ([min, max])=>{
        if (min && max) {
            onChange({
                min,
                max
            });
        }
        DataLayer.pushEvent({
            event: 'filter_applied',
            filter_type: facetLabel,
            filter_value: {
                min,
                max
            }
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-input-price-range"
    }, /*#__PURE__*/ React.createElement(RangeSlider, {
        value: [
            range.min,
            range.max
        ],
        min: min1,
        max: max1,
        currency: currency,
        onChange: ([min, max])=>{
            if (min && max) {
                setRange({
                    min,
                    max
                });
            }
        },
        onAfterChange: handleAfterChange,
        renderNumber: renderNumber,
        ariaLabel: getLabel('search.filters.pricerange.select', {
            defaultValue: 'Select a price range'
        })
    }));
};

export { FacetInputPriceRange as default };
//# sourceMappingURL=FacetInputPriceRange.js.map
